import React from "react";
import createThemedStyles from "./createThemedStyles";
import ThemeContext from "./ThemeContext";

export default function withTheme(Component, styles, themes) {
  return function ThemedComponent(props) {
    return (
      <ThemeContext.Consumer>
        {(name) => {
          let themedStyles = {};

          if (styles && themes) {
            themedStyles = createThemedStyles(styles, themes[name]);
          }

          return (
            <Component {...props} theme={{ name, styles: themedStyles }} />
          );
        }}
      </ThemeContext.Consumer>
    );
  };
}
